<template src="./ReportDocuments.html"></template>

<script>
import UsersCompliance from "../../../components/Forms/UsersCompliance/UsersCompliance";
import Companies from "../../../components/Forms/Companies/Companies";
import { OnlyAdmin, AdminCompliance } from "../../../utils/roles";
import {
  uploadFile,
  saveDocumentReport,
  updateDocuments,
  getUserComplianceCompanies,
} from "../../../services";
import { mapGetters } from "vuex";

const CompanyDocumentStatusMap = [
  { text: "Próximo a vencer", value: "ABOUT_TO_EXPIRE" },
  { text: "Actualizado", value: "UPDATED" },
];

export default {
  name: "ReportDocuments",
  components: { UsersCompliance, Companies },
  data() {
    return {
      valid: false,
      infoDocument: {
        status: "ABOUT_TO_EXPIRE",
        name: "",
        client: "",
        responsible: {
          id: null,
          fullname: "",
        },
        plannedDate: "",
        dateExecution: "",
        observation: "",
        documentAssociated: null,
        planDocument: null,
      },
      responsibleName: "",
      isEditing: false,
      // responsibleId: null,
      menu: false,
      menu1: false,
      newFile: null,
      attachedFiles: [],
      fileIdCounter: 1,
      update: false,
      documentStatuses: CompanyDocumentStatusMap,
      companies: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    OnlyAdmin,
    AdminCompliance,
  },
  created() {
    if (this.$route.query.docKey) {
      const docData = sessionStorage.getItem(this.$route.query.docKey);
      if (docData) {
        this.$route.params.documentToEdit = JSON.parse(docData);
        sessionStorage.removeItem(this.$route.query.docKey);
      }
    }
    if (this.$route.params.documentToEdit) {
      this.loadDocumentForEdit(this.$route.params.documentToEdit);
      this.update = true;
    }
    this.listCompanies();
  },
  mounted() {
    if (
      !this.$route.params.documentToEdit &&
      !this.infoDocument.responsible.id
    ) {
      this.setResponsible();
    }
  },
  methods: {
    loadDocumentForEdit(documentData) {
      this.infoDocument = {
        id: documentData.id || null,
        status: documentData.status || "",
        name: documentData.name || "",
        client: documentData.company ? documentData.company.id : null,
        responsible: documentData.responsibleUser
          ? {
              id: documentData.responsibleUser.id,
              fullname: `${documentData.responsibleUser.name} ${documentData.responsibleUser.lastName}`,
            }
          : { id: null, fullname: "" },
        plannedDate: documentData.plannedDate || "",
        dateExecution: documentData.executionDate || "",
        observation: documentData.generalObservation || "",
        documentAssociated: null,
        planDocument: documentData.planDocument || null,
      };

      if (documentData.versions && documentData.versions.length > 0) {
        this.attachedFiles = documentData.versions.map((file) => ({
          name: file.fileName,
          observation: file.observation || "",
          versionNumber: file.versionNumber || 1,
          url: file.url,
          id: file.id,
          fileObject: null,
        }));

        const maxId = Math.max(...this.attachedFiles.map((f) => f.id || 0), 0);
        this.fileIdCounter = maxId + 1;
      } else {
        this.attachedFiles = [];
        this.fileIdCounter = 1;
      }

      this.setResponsibleName();
    },

    setResponsible() {
      if (this.user && this.user.id) {
        this.infoDocument.responsible = {
          id: this.user.id,
          fullname: `${this.user.name} ${this.user.lastName}`,
          name: this.user.name,
          lastName: this.user.lastName,
        };
        this.responsibleName = this.infoDocument.responsible.fullname;
      }
    },
    setResponsibleName() {
      if (
        this.infoDocument.responsible &&
        this.infoDocument.responsible.fullname
      ) {
        this.responsibleName = this.infoDocument.responsible.fullname;
      } else {
        if (this.user && this.user.name && this.user.lastName) {
          this.responsibleName = `${this.user.name} ${this.user.lastName}`;
        } else {
          this.responsibleName = "";
        }
      }
    },
    toggleEdit() {
      this.isEditing = !this.isEditing;
      if (!this.isEditing) {
        this.setResponsibleName();
      }
    },
    updateResponsible(userSelected) {
      if (userSelected) {
        this.infoDocument.responsible = {
          id: userSelected.id,
          fullname: `${userSelected.name} ${userSelected.lastName}`,
          name: userSelected.name,
          lastName: userSelected.lastName,
        };
        this.responsibleName = this.infoDocument.responsible.fullname;
      } else {
        this.infoDocument.responsible = { id: null, fullname: "" };
        this.responsibleName = "";
      }
    },
    addSelectedFile(files) {
      if (files) {
        Array.from(files).forEach((file) => {
          const currentMaxVersion = this.attachedFiles.reduce(
            (max, f) => Math.max(max, f.versionNumber || 0),
            0
          );
          const newVersion = parseFloat((currentMaxVersion + 1.0).toFixed(1));

          this.attachedFiles.push({
            // id: this.fileIdCounter++,
            name: file.name,
            fileObject: file,
            observation: "",
            versionNumber: newVersion,
            url: null,
          });
        });
        this.newFile = null;
      }
    },
    removeAttachedFile(index) {
      const newAttachedFiles = [...this.attachedFiles];
      newAttachedFiles.splice(index, 1);
      this.attachedFiles = newAttachedFiles;
    },

    async uploadSingleFile(fileObject) {
      try {
        const fileName = `${new Date().getTime()}-${fileObject.name}`;
        const url = await uploadFile("Documents", fileName, fileObject);
        return url;
      } catch (error) {
        console.error("Error al subir un archivo individual:", error);
        throw new Error(
          `Fallo al subir el archivo ${fileObject.name}: ${
            error.message || error
          }`
        );
      }
    },

    async saveAndUpdateReport() {
      // if (!this.$refs.form.validate()) {
      //   this.$swal({
      //     text: 'Por favor, completa todos los campos requeridos.',
      //     buttons: false,
      //     icon: 'warning',
      //     timer: 3000
      //   });
      //   return;
      // }

      try {
        const finalAttachments = [];

        for (const fileItem of this.attachedFiles) {
          let fileUrl = fileItem.url;

          if (fileItem.fileObject) {
            fileUrl = await this.uploadSingleFile(fileItem.fileObject);
            fileItem.fileObject = null;
            fileItem.url = fileUrl;
          }

          const attachmentPayload = {
            name: fileItem.name,
            observation: fileItem.observation,
            versionNumber: parseFloat(fileItem.versionNumber),
            url: fileUrl,
          };

          if (fileItem.id) {
            attachmentPayload.id = fileItem.id;
          }

          finalAttachments.push(attachmentPayload);
        }

        const documentPayload = {
          status: this.infoDocument.status,
          name: this.infoDocument.name,
          client: this.infoDocument.client,
          responsibleId: this.infoDocument.responsible
            ? this.infoDocument.responsible.id
            : null,
          plannedDate: this.infoDocument.plannedDate,
          dateExecution: this.infoDocument.dateExecution,
          observation: this.infoDocument.observation,
          // documentAssociated: this.infoDocument.documentAssociated,
          attachments: finalAttachments,
        };

        if (!this.update) {
          await saveDocumentReport(documentPayload);
        } else {
          documentPayload.companyId = this.infoDocument.client.id;
          documentPayload.id = this.infoDocument.id;
          await updateDocuments(documentPayload);
        }

        this.$swal({
          text: "Documento guardado con éxito.",
          buttons: false,
          icon: "success",
          timer: 3000,
        });

        this.reset();
        this.$router.push("/gestor-documental");
      } catch (error) {
        console.error("Error en saveAndUpdateReport:", error);
        this.$swal({
          text: `Ocurrió un error: ${error.message || "Intenta más tarde."}`,
          buttons: false,
          icon: "error",
          timer: 5000,
        });
      }
    },
    reset() {
      this.infoDocument = {
        id: null,
        status: "ABOUT_TO_EXPIRE",
        name: "",
        client: null,
        responsible: { id: null, fullname: "" },
        plannedDate: "",
        dateExecution: "",
        observation: "",
        documentAssociated: null,
      };
      this.responsibleName = "";
      this.isEditing = false;
      this.newFile = null;
      this.attachedFiles = [];
      this.fileIdCounter = 1;
      this.setResponsible();
    },
    async listCompanies() {
      try {
        this.companies = await getUserComplianceCompanies();
      } catch (err) {
        console.error("Error al listar las empresas:", err);
      }
    },
  },
};
</script>
